import { BarChart3 } from "lucide-react";

import { useTranslation } from "@/i18n";
import { formatCompactNumberID } from "@/lib/format";
import { MetricCard } from "./metric-card";

interface RequestsCardProps {
  value: number;
  isLoading: boolean;
  isError: boolean;
}

export function RequestsCard({
  value,
  isLoading,
  isError,
}: RequestsCardProps) {
  const { t } = useTranslation();
  return (
    <MetricCard
      label={t("dashboard.requests.label")}
      icon={BarChart3}
      isLoading={isLoading}
      isError={isError}
    >
      <div className="flex items-baseline gap-2">
        <span className="text-3xl font-medium text-ocean-800">
          {formatCompactNumberID(value)}
        </span>
      </div>
      <div className="mt-2 text-xs text-neutral-600">
        {t("dashboard.requests.caption")}
      </div>
    </MetricCard>
  );
}
